export default __webpack_public_path__ + "static/3-small-e905e46fc8e689adf4390d7b38d5cd11.jpg";